<template>
  <section class="content">
    <a  href="#"  @click.prevent="exportCSV()" class="p-grid p-col-12">
            <img src="../../../../static/img/excel.png" style="height: 3em;width: 3em;"/>
         </a>
    <DataTable :value="eventRegistrationReports" :paginator="true" :rows="8"  :filters="filters"
    class="p-datatable-responsive p-datatable-customers" data-key="id" ref="po">
      <Column header="S.N"/>
        <Column header="Reg Date" field="regDate" :sortable="true" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['regDate']" />
        </template>
      </Column>
       <Column header="Time" :sortable="true" field="regTime"  filterMatchMode="contains">
         <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['regTime']" />
          </template>
        </Column>
      <Column header="Name" field="name" :sortable="true" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>
      <Column header="Contact" field="contactNumber" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
        </template>
      </Column>
       <Column header="Address" field="address" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']" />
        </template>
      </Column>
      <!-- <Column header="Role" field="role" filterField="role" filterMatchMode="contains"/> -->
       <Column header="Email" field="email" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['email']" />
        </template>
      </Column>

      <Column header="Payment Details" field="paymentDetails" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['paymentDetails']" />
        </template>
      </Column>
      <Column header="Message"  field="message" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['message']" />
        </template>
      </Column>

      <Column header="FeedBack"  field="feedback" :sortable="true" filterMatchMode="contains">
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['feedback']" />
        </template>
      </Column>
      <!-- <Column header="Action">
      <template #body="slotProps">
         <Button class="p-button-raised p-button-success" @click ="openEditDialog(slotProps.data)" icon="pi pi-pencil"/>
         <Button class="p-button-raised p-button-danger" icon="pi pi-trash"
         @click="openDeleteDialog(slotProps.data.id)"/>
      </template>
      </Column> -->
     <template #empty>No record found</template>
    </DataTable>
    <!-- <Dialog @deleted ="deleteUser" @cancel="cancel" v-model="dialogShow"/> -->
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import Tooltip from 'primevue/tooltip'
export default {
  name: 'userList',
  data () {
    return {
      dialogShow: false,
      userId: null,
      filters: {},
      columnList: '',
      status: 'ACTIVE'
    }
  },
  computed: {
    eventRegistrationReports() {
      return this.$store.state.eventManagement.eventRegistrationReports
    }
  },
  mounted() {
    this.eventRegistrationReport()
    this.columnNames()
  },
  methods: {
    async eventRegistrationReport() {
      await this.$store.dispatch('loadEventRegisterReport')
    },
    async deleteUser(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty',
          messageType: 'error'
        }
        this.$emit('delete-user', message)
        this.dialogShow = true
        return
      }
      let deleteReason = {
        userId: this.userId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteUser', deleteReason)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-user', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('deleteUser', message)
      }
      this.closeDialog()
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/eventManagementExcelReport/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'eventRegData.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    RadioButton,
    Tooltip
  }
}
</script>



// WEBPACK FOOTER //
// eventReport.vue?2f9c53cc